import createStore from "astrid-helpers/src/createStore";

const urlChannelId = new URLSearchParams(window.location.search).get("discussion");

export const [getDiscussion, setDiscussion, useDiscussion, onDiscussion, resetDiscussion] = createStore({
	isOpen: !!urlChannelId,
	channelId: urlChannelId,
});
